import { Button, Divider, Popover, Text } from "@mantine/core";
import dayjs from "dayjs";
import { Fragment, useCallback, useState } from "react";
import { useSelector } from "src/redux/hooks";

const PendingRequestsInfo = () => {
  const [opened, setOpened] = useState(false);

  const pendingRequests = useSelector(
    state => state.pendingRequestsSlice.pendingRequests,
  );

  const toggle = useCallback(() => {
    setOpened(prev => !prev);
  }, []);

  if (pendingRequests.length === 0) {
    return;
  }

  return (
    <>
      <Popover opened={opened} onChange={setOpened}>
        <Popover.Target>
          <Button
            ml="auto"
            variant="white"
            color="transparent"
            onClick={
              toggle
            }>{`Pending Requests: ${pendingRequests.length}`}</Button>
        </Popover.Target>
        <Popover.Dropdown maw="30vw">
          {pendingRequests.map(req => (
            <Fragment key={req.req}>
              <Text size="xs">
                {`${req.action} ${
                  req.lbname ? `(${req.lbname})` : ""
                } - ${dayjs(req.created).format("D MMM YYYY HH:mm")}`}
              </Text>
              <Divider />
            </Fragment>
          ))}
        </Popover.Dropdown>
      </Popover>
    </>
  );
};

export default PendingRequestsInfo;
